import script from "./UPlan.vue?vue&type=script&setup=true&lang=ts"
export * from "./UPlan.vue?vue&type=script&setup=true&lang=ts"

import "./UPlan.vue?vue&type=style&index=0&id=aad2b850&lang=css"

const __exports__ = script;

export default __exports__